import { connect } from 'react-redux';
import { formStartNew } from '../../actions';
import FormName from './FormNamer';

const mapStateToProps = ({ formBuilder }) => {
    return {
        form: formBuilder.form,
    };
};

const mapDispatchToProps = (dispatch) => ({
    onStartNew: (name, callBack) => {
        dispatch(formStartNew({ name, callBack }));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(FormName);
